import type {
    SeverityLevelPayload,
    SeverityLevelResponse,
} from '@/types/apps/severity-level-type.type';
import type {
    ApiResponse,
    PaginatedResult,
    QueryParams,
} from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import type { Creatable } from '@/types/service/creatable.interface';
import type { Deletable } from '@/types/service/deletable.interface';
import type { Indexable } from '@/types/service/indexable.interface';
import type { Showable } from '@/types/service/showable.interface';
import type { Updatable } from '@/types/service/updatable.interface';

type SeverityLevelListResponse = ApiResponse<
    PaginatedResult<SeverityLevelResponse>
>;

export class SeverityLevelService
    implements Showable, Updatable, Deletable, Creatable, Indexable
{
    public constructor(private apiClient: BaseApiClientInterface) {}

    protected endpoints = {
        base: () => '/api/SeverityLevels',
        detail: (id: string) => `/api/SeverityLevels/${id}`,
    };

    public index(params?: QueryParams): Promise<SeverityLevelListResponse> {
        return this.apiClient.fetchApi(this.endpoints.base(), params);
    }

    public detail(
        id: string,
        params?: QueryParams
    ): Promise<ApiResponse<SeverityLevelResponse>> {
        const url = this.endpoints.detail(id);

        return this.apiClient.fetchApi(url, params);
    }

    public create(
        payload: SeverityLevelPayload
    ): Promise<ApiResponse<SeverityLevelResponse>> {
        return this.apiClient.postApi(this.endpoints.base(), payload);
    }

    public update(
        id: string,
        payload: SeverityLevelPayload
    ): Promise<ApiResponse<SeverityLevelResponse>> {
        const form = this.apiClient.buildFormData(payload);

        return this.apiClient.putApi(this.endpoints.detail(id), form);
    }
    public destroy(
        ids: string[],
        isHardDeleted: boolean = false
    ): Promise<ApiResponse<void>> {
        const url = this.endpoints.base();

        return this.apiClient.destroyApi<void>(url, ids, isHardDeleted);
    }
}
